<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oa3snC/tc-custom/9781940669007.jpg?1720280501600" alt="This image is the cover for the book Silent Hunters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silent Hunters
      </h1>
      <p class="bookDescription body article font2">
        <b>The compelling true stories of six little-known U-boat commanders and their dramatic WWII careers.</b><br/>  <br/> When World War II erupted across Europe in 1939, Germany knew it couldn’t hope to compete with the Royal Navy in a head-to-head naval war. Left with no viable alternatives, the U-Bootwaffe wagered everything on the submarine in a desperate attempt to sink more tonnage than the Allies could construct. Some of these “silent hunters” who slipped out of their shelters along Europe's shores to stalk their prey have enjoyed considerable recognition in the years since. While most aspects of the bitter struggle have been told and retold from both the Axis and Allied points of view, the careers of some highly effective U-boat commanders have languished in undeserved obscurity. The profiles of six such commanders are presented in this collection of essays.<br/>  <br/> They include Englebert Endrass, whose spectacular career before being lost off the coast of Gibraltar is described here by his best friend and fellow ace Enrich Topp, who wrote this while on his fifteenth War Patrol; Karl-Friedrich Merten, who was ranked among the war’s top tonnage aces; Ralph Kapitsky, whose U-615 suicidal surface-to-air battle in the Caribbean allowed many of his fellow submariners to escape into the Atlantic; Fritz Guggenberger, who sank an aircraft carrier and organized the biggest POW escape attempt in American history; Victor Oehrn, a former staff officer of Karl Dönitz's; and Heinz Eck, who was executed by the British.<br/>  <br/><i>Includes photographs</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Theodore P. Savas
      </h2>
      
      <p class="authorDescription body article">Theodore P. Savas graduated from The University of Iowa College of Law in 1986 (With Distinction). He practiced law in Silicon Valley for twelve years and co-founded Savas Woodbury Publishers (subsequently Savas Publishing) in 1990. The company was sold to an East coast publisher in 2001. He has been teaching legal, history, and business college classes since 1992.He is the author or editor of fourteen books (published in five languages) including A Guide to the Battles of the American Revolution (with J. David Dameron, Spellmount and SBLLC, 2006), Hunt and Kill: U-505 and the U-Boat War in the Atlantic (Spellmount, SBLLC, 2004), Silent Hunters: German U-boat Commanders of World War II (Campbell, 1997; Naval Institute Press, 2003) and Nazi Millionaires: The Allied Search for Hidden SS Gold  (Casemate, 2002), as well as a score of articles in a variety of journals and magazines. He also wrote an opinion-editorial column for a northern California newspaper</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a829944